<template>
  <div class="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
    <!-- Header（可點擊收合）-->
    <button
      type="button"
      class="flex items-center gap-2 px-4 py-3 w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300"
      :class="collapsed ? '' : 'border-b border-slate-100'"
      :aria-expanded="!collapsed"
      :aria-label="collapsed ? $t('permission_expand_aria') : $t('permission_collapse_aria')"
      @click="collapsed = !collapsed"
    >
      <v-icon size="14" color="#94a3b8">mdi-card-account-details-outline</v-icon>
      <span class="text-sm font-semibold text-slate-700">
        {{ $t('permission_user_basic_info') }}
      </span>
      <span
        v-if="saving"
        class="ml-auto inline-flex items-center gap-1 text-[11px] text-indigo-500"
      >
        <v-icon size="12" color="#6366f1" class="animate-spin">mdi-loading</v-icon>
        {{ $t('permission_assignment_saving') }}
      </span>
      <v-icon :class="saving ? '' : 'ml-auto'" size="16" color="#94a3b8">{{ collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
    </button>

    <div v-show="!collapsed" class="p-4 space-y-4">
      <!-- 姓名（唯讀）-->
      <div>
        <label class="block text-xs font-medium text-slate-500 mb-1">
          {{ $t('permission_user_name') }}
        </label>
        <div class="flex items-center gap-1.5 text-sm font-medium text-slate-800">
          <v-icon size="12" color="#94a3b8">mdi-lock-outline</v-icon>
          {{ displayName(user) || '-' }}
        </div>
      </div>

      <!-- 所屬部門 -->
      <div>
        <label class="block text-xs font-medium text-slate-500 mb-1">
          {{ $t('permission_primary_department') }}
        </label>
        <select
          :value="primaryDepartmentId || ''"
          :disabled="saving"
          class="w-full text-sm px-3 py-2 rounded-lg border border-slate-200 bg-white focus:outline-none focus:ring-1 focus:ring-indigo-400 cursor-pointer disabled:bg-slate-50 disabled:cursor-wait"
          @change="onDeptChange($event)"
        >
          <option value="">{{ $t('permission_dept_unassigned') }}</option>
          <option
            v-for="d in departments"
            :key="d.id"
            :value="d.id"
          >
            {{ d.name }}
          </option>
        </select>
      </div>

      <!-- 綁定群組 -->
      <div>
        <label class="block text-xs font-medium text-slate-500 mb-2">
          {{ $t('permission_bind_groups') }}
        </label>
        <div class="flex flex-wrap gap-1.5">
          <button
            v-for="g in groups"
            :key="g.id"
            type="button"
            :disabled="saving"
            class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium transition-all cursor-pointer disabled:cursor-wait"
            :class="isSelected(g.id)
              ? 'bg-indigo-500 text-white shadow-sm hover:bg-indigo-600'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200'"
            @click="toggleGroup(g.id)"
          >
            <v-icon
              size="10"
              :color="isSelected(g.id) ? 'white' : '#64748b'"
            >
              {{ isSelected(g.id) ? 'mdi-check' : 'mdi-plus' }}
            </v-icon>
            {{ g.name }}
          </button>
          <span
            v-if="groups.length === 0"
            class="text-xs text-slate-400 italic"
          >
            {{ $t('permission_empty_list') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { displayName } from '@/js/permission-helpers'

export default {
  name: 'UserBasicInfoPanel',
  props: {
    user: { type: Object, default: null },
    departments: { type: Array, default: () => [] },
    groups: { type: Array, default: () => [] },
    primaryDepartmentId: { type: [String, Number], default: null },
    userGroupIds: { type: Array, default: () => [] },
    saving: { type: Boolean, default: false }
  },
  data () {
    return { collapsed: false }
  },
  methods: {
    displayName,
    // Case-insensitive GUID 比對（API 回 Guid / group.id 大小寫可能不一致）
    _eqId (a, b) {
      return String(a || '').toLowerCase() === String(b || '').toLowerCase()
    },
    isSelected (gid) {
      return this.userGroupIds.some(x => this._eqId(x, gid))
    },
    toggleGroup (gid) {
      if (this.saving) return
      const next = this.isSelected(gid)
        ? this.userGroupIds.filter(x => !this._eqId(x, gid))
        : [...this.userGroupIds, gid]
      this.$emit('change-groups', next)
    },
    onDeptChange (event) {
      const raw = event && event.target ? event.target.value : ''
      this.$emit('change-department', raw === '' ? null : raw)
    }
  }
}
</script>
